import { AmericanExpressIcon, ApplePayIcon, DefaultCardIcon, MasterCardIcon, VisaIcon } from 'assets/icons/';
import React from 'react';

interface CardIconProps {
  type: string;
}

const CardIcon: React.FC<CardIconProps> = ({ type }) => {
  switch (type) {
    case 'Visa':
      return <VisaIcon />;
    case 'Mastercard':
      return <MasterCardIcon />;
    case 'Amex':
      return <AmericanExpressIcon />;
    case 'ApplePay':
      return <ApplePayIcon />;
    default:
      return <DefaultCardIcon />;
  }
};

export default CardIcon;
